import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { areaClusters } from '../../../lib/schiek-content';

export default function AreasPreviewSection() {
  return (
    <section className="bg-[#111827] py-16 text-white" aria-labelledby="areas-preview-heading">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-[0.95fr_1.05fr] lg:px-8">
        <div>
          <p className="text-sm font-semibold text-amber-100">Berlin in Zonen lesen</p>
          <h2 id="areas-preview-heading" className="mt-3 max-w-xl text-3xl font-semibold leading-tight sm:text-4xl">
            Die Bezirke sind jetzt sichtbar statt versteckt.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-8 text-slate-300">
            Schiek deckt Berlin und das direkte Umland ab. Die Einsatzgebiete sind nicht nur eine Unterseite,
            sondern ein eigener Navigationspunkt mit klarer lokaler Struktur.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Link
              to="/einsatzgebiete"
              className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-5 py-3 text-sm font-semibold text-slate-950 transition-colors hover:bg-amber-300"
            >
              Bezirke öffnen
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold text-white transition-colors hover:border-amber-300/30 hover:bg-white/10"
            >
              Kontakt
            </Link>
          </div>
        </div>

        <div className="rounded-[1.75rem] border border-white/10 bg-white/5 p-5">
          <p className="text-sm font-semibold text-amber-100">Gebietskarte</p>
          <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {areaClusters.slice(0, 9).map((area) => (
              <div key={area} className="rounded-2xl border border-white/10 bg-[#0b1220] px-4 py-3 text-sm text-slate-200">
                {area}
              </div>
            ))}
          </div>
          <p className="mt-4 text-sm leading-7 text-slate-300">
            Bezirke und Umland sind direkt verlinkt. So sieht man direkt, welche Regionen Schiek tatsächlich abdeckt.
          </p>
        </div>
      </div>
    </section>
  );
}
